import React, { FC } from 'react';
import { useRenderFields } from 'modules/core/hooks/useRenderFields';
import { IField } from 'modules/core/types';
import { useFormContext } from 'react-hook-form';

import { Panel } from '../Panel/Panel';

interface IPanelWithFields {
  fieldsConfig: IField[];
  title: string;
  useTouchedFields?: boolean;
}

export const PanelWithFields: FC<IPanelWithFields> = ({ fieldsConfig, title, useTouchedFields = false }) => {
  const {
    formState: { touched },
  } = useFormContext();

  const fields = useRenderFields(fieldsConfig, touched, useTouchedFields);

  return <Panel title={title}>{fields}</Panel>;
};
